var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSitejabberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.188,
    height: 24.923,
    viewBox: "0 0 25.188 24.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.851,
    y1: 0.129,
    x2: 0.242,
    y2: 0.746,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#52bfca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#7238df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.654,
    y1: 1.481,
    x2: 1.304,
    y2: -0.033,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#25e2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19a6d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.532,
    y1: 1.624,
    x2: 1.075,
    y2: -0.279,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#e55ec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8225d0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_light.1692287721",
    transform: "translate(0.006 0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60245",
    "data-name": "Path 60245",
    d: "M23.9,17.472,17.29,17.6a.765.765,0,0,0-.594.322,56.447,56.447,0,0,1-4.606,6.117.85.85,0,0,1-1.312-.2c-.05-.1-.124-.2-.124-.223-.4-.916-1.61-6.216-2.155-6.885C7.83,15.936,2.085,14.5,1.193,14.2a.922.922,0,0,1-.322-1.535,47.513,47.513,0,0,1,5.5-4.458.73.73,0,0,0,.371-.619l-.1-6.29A.684.684,0,0,1,7.607.656,25.2,25.2,0,0,1,13.13,4.223a.667.667,0,0,0,.693.2,36.044,36.044,0,0,1,7.454-1.412A.679.679,0,0,1,22,3.777a37.453,37.453,0,0,1-1.263,6.786.624.624,0,0,0,.124.644c.669.867,2.254,3.046,3.64,5.225A.692.692,0,0,1,23.9,17.472Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60246",
    "data-name": "Path 60246",
    d: "M16.4,9.72a1.512,1.512,0,0,1-1.486,1.511A1.5,1.5,0,0,1,13.427,9.72a1.486,1.486,0,1,1,2.972,0Zm7.5,7.751L17.29,17.6a.765.765,0,0,0-.594.322,56.447,56.447,0,0,1-4.606,6.117.85.85,0,0,1-1.312-.2c-.05-.1-.124-.2-.124-.223-.4-.916-1.61-6.216-2.155-6.885C7.83,15.936,2.085,14.5,1.193,14.2a.922.922,0,0,1-.322-1.535,47.513,47.513,0,0,1,5.5-4.458.73.73,0,0,0,.371-.619l-.1-6.29A.684.684,0,0,1,7.607.656,25.2,25.2,0,0,1,13.13,4.223a.667.667,0,0,0,.693.2,36.044,36.044,0,0,1,7.454-1.412A.679.679,0,0,1,22,3.777a37.453,37.453,0,0,1-1.263,6.786.624.624,0,0,0,.124.644c.669.867,2.254,3.046,3.64,5.225A.692.692,0,0,1,23.9,17.472ZM20.014,5.213a.278.278,0,0,0-.322-.322c-6.686.693-12.8,5.572-14.785,7.33a.556.556,0,0,0,.173.941s4.259.693,5.275,1.56c.743.644,1.461,4.507,1.461,4.507a.542.542,0,0,0,.892.173A26.7,26.7,0,0,0,20.014,5.213Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60247",
    "data-name": "Path 60247",
    d: "M11.277,30.6c-.05-.223-.124-.446-.2-.693l-2.13,2.254a.951.951,0,0,0-.223.619A.8.8,0,0,0,9,33.4a.844.844,0,0,0,.594.223.9.9,0,0,0,.644-.272l1.412-1.486Q11.463,31.346,11.277,30.6Z",
    transform: "translate(-2.58 -9.293)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60248",
    "data-name": "Path 60248",
    d: "M7.758,25.193a4.937,4.937,0,0,0-.916-.4l-5.3,5.4a.86.86,0,0,0-.248.619.821.821,0,0,0,.248.619.977.977,0,0,0,.619.248.96.96,0,0,0,.644-.248l5.25-5.349A5.291,5.291,0,0,0,7.758,25.193Z",
    transform: "translate(-0.225 -7.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60249",
    "data-name": "Path 60249",
    d: "M2.829,23.021,1.07,24.8a.977.977,0,0,0-.248.619.821.821,0,0,0,.248.619.977.977,0,0,0,.619.248.926.926,0,0,0,.619-.248l2.452-2.477C4.067,23.392,3.374,23.194,2.829,23.021Z",
    transform: "translate(-0.075 -7.109)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60250",
    "data-name": "Path 60250",
    d: "M11.277,30.6c-.05-.223-.124-.446-.2-.693l-2.13,2.254a.951.951,0,0,0-.223.619A.8.8,0,0,0,9,33.4a.844.844,0,0,0,.594.223.9.9,0,0,0,.644-.272l1.412-1.486Q11.463,31.346,11.277,30.6Z",
    transform: "translate(-2.58 -9.293)",
    stroke: "#707070",
    strokeWidth: 1.171,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60251",
    "data-name": "Path 60251",
    d: "M2.829,23.021,1.07,24.8a.977.977,0,0,0-.248.619.821.821,0,0,0,.248.619.977.977,0,0,0,.619.248.926.926,0,0,0,.619-.248l2.452-2.477C4.067,23.392,3.374,23.194,2.829,23.021Z",
    transform: "translate(-0.075 -7.109)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.171
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60252",
    "data-name": "Path 60252",
    d: "M7.758,25.193a4.937,4.937,0,0,0-.916-.4l-5.3,5.4a.86.86,0,0,0-.248.619.821.821,0,0,0,.248.619.977.977,0,0,0,.619.248.96.96,0,0,0,.644-.248l5.25-5.349A5.291,5.291,0,0,0,7.758,25.193Z",
    transform: "translate(-0.225 -7.672)",
    fill: "none",
    stroke: "rgba(112,112,112,0.5)",
    strokeWidth: 1.171
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40972",
    "data-name": "Group 40972",
    transform: "translate(0.585 0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60253",
    "data-name": "Path 60253",
    d: "M23.9,17.472,17.29,17.6a.765.765,0,0,0-.594.322,56.447,56.447,0,0,1-4.606,6.117.85.85,0,0,1-1.312-.2c-.05-.1-.124-.2-.124-.223-.4-.916-1.61-6.216-2.155-6.885C7.83,15.936,2.085,14.5,1.193,14.2a.922.922,0,0,1-.322-1.535,47.513,47.513,0,0,1,5.5-4.458.73.73,0,0,0,.371-.619l-.1-6.29A.684.684,0,0,1,7.607.656,25.2,25.2,0,0,1,13.13,4.223a.667.667,0,0,0,.693.2,36.044,36.044,0,0,1,7.454-1.412A.679.679,0,0,1,22,3.777a37.453,37.453,0,0,1-1.263,6.786.624.624,0,0,0,.124.644c.669.867,2.254,3.046,3.64,5.225A.692.692,0,0,1,23.9,17.472Z",
    transform: "translate(-0.585 -0.59)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.171
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitejabberIcon);
export default __webpack_public_path__ + "static/media/Sitejabber_icon.c669b6401c1a4032b04858b924a74c07.svg";
export { ForwardRef as ReactComponent };